<template>
  <div class="typed-on-paper-tabs-padding">
    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'CampaignRules'}">
      <div class="heading">Campaign Rules</div>
    </DivLinkButton>

    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'RulesOfEngagement'}">
      <div class="heading">Rules of Engagement</div>
    </DivLinkButton>

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'Joining'}">-->
<!--      <div class="heading">Joining</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'Campaigns'}">-->
<!--      <div class="heading">Campaigns</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'CampaignsRules'}">-->
<!--      <div class="heading">Rules</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'CampaignProcedures'}">-->
<!--      <div class="heading">Procedures</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'AfterActionReports'}">-->
<!--      <div class="heading">After Action Reports</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'Structure'}">-->
<!--      <div class="heading">Structure</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'AboutUnits'}">-->
<!--      <div class="heading">Units</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'Ranks'}">-->
<!--      <div class="heading">Ranks</div>-->
<!--    </DivLinkButton>-->

<!--    <DivLinkButton class="typed-on-paper-tabs" v-bind="{routeName: 'Comms'}">-->
<!--      <div class="heading">Communications</div>-->
<!--    </DivLinkButton>-->

  </div>
</template>

<script>
import DivLinkButton from "../basic_comp/DivLinkButton"
import HideableDiv from "../basic_comp/HideableDiv"

export default {
  name: "RulesInfoSideNav",
  components: {
    DivLinkButton,
    HideableDiv
  },
  methods: {

    navigate_to: function (link) {

      location.replace(link);
    }
  }

}
</script>

<style scoped>

.subcontent-buttons{
  font-size: 1em;
  margin: 2px 0px 0px 15px;
  width: calc(100% - 15px - 26px);
}

</style>



// WEBPACK FOOTER //
// src/components/info/RulesInfoSideNav.vue